import {VehicleIncidentTypeEnum} from '@/services/api-clients';


export function vehicleIncidentTypeColorBaseFilter(type: VehicleIncidentTypeEnum) {
  switch (type) {
    case VehicleIncidentTypeEnum.Crash: return 'red';
    case VehicleIncidentTypeEnum.Fee: return 'blue';
    case VehicleIncidentTypeEnum.Workshop: return 'indigo';
    case VehicleIncidentTypeEnum.ReceiveFromWorkshop: return 'indigo';
    case VehicleIncidentTypeEnum.Failure: return 'orange';
    case VehicleIncidentTypeEnum.Other: return 'grey';
    case VehicleIncidentTypeEnum.Convey: return 'blue';
    case VehicleIncidentTypeEnum.Return: return 'blue';
    case VehicleIncidentTypeEnum.TownTransfer: return 'green';
    case VehicleIncidentTypeEnum.Theft: return 'brown';
    case VehicleIncidentTypeEnum.BackToFleet: return 'purple';
    case VehicleIncidentTypeEnum.Maintain: return 'blue-grey';
    default: return 'primary';
  }
}
